// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jgp-NPEOE","totaliser":"jgp-2zsYP","raised_by":"jgp-2Htv7"};